import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Popconfirm } from "antd";
import SL_Button from "../buttons/Button";

export function ColumnButtonCofirm({
    onConfirm,
    param,
    activeParamMessage,
    unactiveParamMessage,
    popConfirmMessage,
    buttonProps = {}
}) {
    return (
        <div style={{ padding: 2 }}>
            <Popconfirm
                placement="topRight"
                title={popConfirmMessage}
                onConfirm={onConfirm}
                icon={<ExclamationCircleOutlined style={{ color: 'red' }} />}
            >
                <SL_Button
                    style={{ minWidth: 80 }}
                    type={'primary'}
                    danger={param ? false : true}
                    {...buttonProps}
                >
                    {param ? activeParamMessage : unactiveParamMessage}
                </SL_Button>
            </Popconfirm>
        </div>
    )
}